import {Formula} from "../../types/formula";
import {MetoroQLQuerySpecifier, MetricSpecifier} from "../../clients/metoro/metrics";
import {
    AggregationFunction,
    EvalType,
    MissingDatapointBehavior,
    MonitorEvaluation,
} from "./MetricAlert";
import {ThresholdComparator} from "./model";

export interface MultiMetricFilter {
    metricSpecifiers: MetricSpecifier[];
    formula?: Formula;
    metoroQlQuery?: MetoroQLQuerySpecifier;
}

export interface MultiMetricAlert {
    filters: MultiMetricFilter;
    monitorEvaluation: MonitorEvaluation;
    eventPayload: AlarmCondition;
}

export interface AlarmCondition {
    condition: ThresholdComparator;
    threshold: number;
}

export const defaultMultiMetricAlert: MultiMetricAlert = {
    filters: {
        metricSpecifiers: [
            {
                metricName: "container_net_tcp_active_connections",
                // @ts-ignore
                metricType: "metric",
                aggregation: AggregationFunction.Sum,
                functions: [],
                filters: new Map(),
                bucketSize: 60,
                splits: []
            }
        ],
    },
    monitorEvaluation: {
        description: "Evaluate metric",
        monitorEvaluationType: EvalType.Static,
        monitorEvalutionPayload: {
            evaluationWindow: 1,
            datapointsToAlarm: 1,
            missingDatapointBehavior: MissingDatapointBehavior.NotBreaching
        }
    },
    eventPayload: {
        condition: ThresholdComparator.GreaterThan,
        threshold: 0
    }
}; 